export default function reducer(
  state = {
    Config: {},
  },
  action
) {
  switch (action.type) {
    case 'SET_GLOBAL_CONFIG_LIST': {
      return { ...state, Config: action.global };
    }
    default:
      return state;
  }
}
